import { useContext } from 'react';
import { TourContext } from '../tourContext/TourContext';

const useTour = () => useContext(TourContext);

export default useTour;